import * as React from "react";
import classNames from "classnames";

export interface IIconEditorialProps extends React.AnchorHTMLAttributes<HTMLElement> {
    svgCodeSmallIcon?: string;
    svgCodeLargeIcon?: string;
    className?: string;
}

const IconEditorial: React.FC<IIconEditorialProps> = props => {
    return (
        <span className={classNames("icon-editorial__wrapper", props.className)}>
            {props.svgCodeLargeIcon && (
                <span
                    className={classNames("icon-editorial", "icon-editorial__large")}
                    dangerouslySetInnerHTML={{ __html: props.svgCodeLargeIcon }}
                />
            )}
            {props.svgCodeSmallIcon && (
                <span
                    className={classNames("icon-editorial", "icon-editorial__small", props.className)}
                    dangerouslySetInnerHTML={{ __html: props.svgCodeSmallIcon }}
                />
            )}
        </span>
    );
};

export default IconEditorial;
